/* ============
 * Purchase Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './product';
import Vue from 'vue';

export default class PurchaseProductTransformer extends Transformer {

  static fetch(purchase) {
    let isPurchaseEdit = purchase.qty_receive.toString();
    if (Vue.router.history.current.name === 'inventory.purchase.edit') {
      isPurchaseEdit = purchase.qty.toString();
    }

    return {
      id: purchase.id,
      name: purchase.product !== undefined ? purchase.product.name : '',
      batchId: purchase.batch_id,
      qty: purchase.qty.toString(),
      productId: purchase.product !== undefined ? productTrans.fetch(purchase.product) : purchase.product_id,
      purchasePrice: purchase.purchase_price.toString(),
      costPrice: purchase.cost_price.toString(),
      purchaseId: purchase.purchase_id,
      notes: purchase.notes,
      qtyReceive: (purchase.qty_receive !== undefined) ? isPurchaseEdit : 0,
      qtyDamage: purchase.qty_damage !== undefined ? purchase.qty_damage.toString() : 0,
      product: purchase.product !== undefined ? productTrans.fetch(purchase.product) : [],
    };
  }

  static send(purchase) {
    const productId = typeof purchase.productId === 'object' ? purchase.productId.id : purchase.productId;
    return {
      purchase_product_id: purchase.id,
      qty: purchase.qty,
      batch_id: purchase.batchId,
      id: productId,
      purchase_price: purchase.purchasePrice,
      cost_price: purchase.costPrice,
      notes: purchase.notes,
      qty_receive: purchase.qtyReceive !== undefined ? purchase.qtyReceive : 0,
      qty_damage: purchase.qtyDamage !== undefined ? purchase.qtyDamage : 0,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/purchaseProduct.js